import { render } from "./facture_create_page.vue?vue&type=template&id=3a2cd2d4"
import script from "./facture_create_page.vue?vue&type=script&lang=js"
export * from "./facture_create_page.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__